<template>
  <div class="sup-table-select" style="display: inline-block; width: 100%;">
    <el-popover
      placement="bottom-start"
      :width="popWidth"
      trigger="click"
      v-model="popVisible"
      popper-class="po-req-sup-dropdown-popper"
      @show="onPopoverShow"
      @hide="onPopoverHide">
      
      <!-- 下拉面板内容：现代极简下拉表格 -->
      <div class="sup-dropdown-container" v-if="popVisible">
        <!-- 顶部搜索栏 -->
        <div class="sup-dropdown-search-bar">
          <el-input
            ref="searchInput"
            size="mini"
            v-model="filterText"
            prefix-icon="el-icon-search"
            placeholder="搜索供应商编码 / 名称..."
            clearable
            @input="onSearchInput"
            @keyup.enter.native="handleEnterSelect"
            class="sup-search-input">
          </el-input>
          <el-button
            size="mini"
            type="text"
            @click="handleClear"
            v-if="value || name"
            class="btn-clear-selection">
            清空
          </el-button>
        </div>

        <!-- 下拉表格本体 -->
        <el-table
          ref="supTable"
          :data="currentPageData"
          border
          size="mini"
          height="230"
          highlight-current-row
          @row-click="handleRowClick"
          class="sup-dropdown-table"
          :header-cell-style="{ background: '#f8fafc', color: '#475569', padding: '4px 0', fontSize: '12px', fontWeight: '600' }"
          :cell-style="{ padding: '3px 0', fontSize: '12px' }">
          
          <el-table-column label="序号" width="50" align="center">
            <template slot-scope="scope">
              <span style="color: #94a3b8;">{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="IDNO" label="供应商编号" width="115" show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="font-family: monospace; font-size: 11px; color: #475569;">{{ scope.row.IDNO }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="SUPNM" label="供应商名称" min-width="190" show-overflow-tooltip>
            <template slot-scope="scope">
              <span :style="{ color: isCurrentSelected(scope.row) ? '#2563eb' : '#0f172a', fontWeight: isCurrentSelected(scope.row) ? '600' : 'normal' }">
                {{ scope.row.SUPNM }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="60" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                :style="{ color: isCurrentSelected(scope.row) ? '#10b981' : '#2563eb', fontWeight: '500', fontSize: '12px' }"
                @click.stop="handleRowClick(scope.row)">
                {{ isCurrentSelected(scope.row) ? '已选' : '选中' }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部微型分页与统计 -->
        <div class="sup-dropdown-footer">
          <span class="sup-count-text">
            共 <strong style="color: #2563eb;">{{ filteredList.length }}</strong> 家
          </span>
          <el-pagination
            small
            layout="prev, pager, next"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            :total="filteredList.length">
          </el-pagination>
        </div>
      </div>

      <!-- 触发区：外观像一个标准的干净 Select 选择输入框 -->
      <div
        slot="reference"
        class="select-trigger-box"
        style="position: relative; width: 100%; cursor: pointer;"
        @mouseenter="hovering = true"
        @mouseleave="hovering = false">
        <el-input
          size="mini"
          :value="name || value"
          :placeholder="placeholder"
          readonly
          class="sup-trigger-input">
          <template slot="suffix">
            <i
              v-if="hovering && (name || value)"
              class="el-input__icon el-icon-circle-close"
              title="清空"
              style="cursor: pointer; color: #94a3b8;"
              @click.stop="handleClear">
            </i>
            <i
              v-else
              :class="['el-input__icon', popVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down']"
              style="cursor: pointer; color: #94a3b8;">
            </i>
          </template>
        </el-input>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'SupTableSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '点击选择供应商'
    },
    popWidth: {
      type: [Number, String],
      default: 470
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      popVisible: false,
      filterText: '',
      currentPage: 1,
      hovering: false
    };
  },
  computed: {
    filteredList() {
      const q = (this.filterText || '').trim().toLowerCase();
      if (!q) return this.options || [];
      return (this.options || []).filter(item => {
        const idno = (item.IDNO || '').toLowerCase();
        const supnm = (item.SUPNM || item.CNAME || '').toLowerCase();
        return supnm.includes(q) || idno.includes(q);
      });
    },
    currentPageData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredList.slice(start, start + this.pageSize);
    }
  },
  methods: {
    isCurrentSelected(row) {
      if (!row) return false;
      if (this.value && row.IDNO === this.value) return true;
      if (this.name && (row.SUPNM === this.name || row.CNAME === this.name)) return true;
      return false;
    },

    onSearchInput() {
      this.currentPage = 1;
    },

    clearFilter() {
      this.filterText = '';
      this.currentPage = 1;
    },

    handleEnterSelect() {
      if (this.currentPageData.length > 0) {
        this.handleRowClick(this.currentPageData[0]);
      }
    },

    onPopoverShow() {
      this.filterText = '';
      this.currentPage = 1;
      this.$nextTick(() => {
        if (this.$refs.searchInput) {
          this.$refs.searchInput.focus();
        }
      });
    },

    onPopoverHide() {
      this.filterText = '';
    },

    handleRowClick(row) {
      if (!row) return;
      const supNo = row.IDNO || '';
      const supNm = row.SUPNM || row.CNAME || supNo;
      this.$emit('input', supNo);
      this.$emit('update:name', supNm);
      this.$emit('change', { IDNO: supNo, SUPNM: supNm, row });
      this.popVisible = false;
    },

    handleClear() {
      this.$emit('input', '');
      this.$emit('update:name', '');
      this.$emit('change', null);
      this.popVisible = false;
    }
  }
};
</script>

<style scoped>
.select-trigger-box >>> .el-input__inner {
  cursor: pointer !important;
  font-size: 12px;
  height: 28px !important;
  line-height: 28px !important;
  background-color: #fff;
  border-color: #e2e8f0;
  border-radius: 4px;
  padding-left: 8px;
  padding-right: 24px;
  transition: all 0.15s ease;
}
.select-trigger-box:hover >>> .el-input__inner {
  border-color: #94a3b8;
}
.select-trigger-box >>> .el-input__icon {
  line-height: 28px !important;
}
</style>

<style lang="less">
/* 专属下拉表格浮层样式：严格限定在 .po-req-sup-dropdown-popper 命名空间下，绝不影响全局其他 Popover */
.po-req-sup-dropdown-popper {
  padding: 8px !important;
  border-radius: 6px !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -4px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #e2e8f0 !important;
  background: #ffffff !important;

  .sup-dropdown-container {
    width: 100%;
  }

  .sup-dropdown-search-bar {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    .sup-search-input .el-input__inner {
      border-radius: 4px;
      font-size: 12px;
      height: 28px;
      line-height: 28px;
      background: #f8fafc;
      border: 1px solid #e2e8f0;
      transition: all 0.15s;

      &:focus {
        background: #fff;
        border-color: #2563eb;
        box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.15);
      }
    }

    .btn-clear-selection {
      font-size: 12px;
      color: #64748b;
      margin-left: 6px;
      padding: 4px 6px;

      &:hover {
        color: #ef4444;
      }
    }
  }

  .sup-dropdown-table {
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #e2e8f0;

    .el-table__header th {
      border-bottom: 1px solid #e2e8f0 !important;
    }

    .el-table__body tr {
      transition: background-color 0.1s;

      &:hover > td {
        background-color: #f8fafc !important;
      }
    }
  }

  .sup-dropdown-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 6px;
    padding: 2px 2px 0;

    .sup-count-text {
      font-size: 11px;
      color: #64748b;
    }

    .el-pagination {
      padding: 0;

      .btn-prev,
      .btn-next,
      .el-pager li {
        background: transparent;
        font-size: 12px;
        min-width: 22px;
        height: 22px;
        line-height: 22px;

        &.active {
          color: #2563eb;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
